import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import classes from "./PageSection.module.scss";
export default function PageSection(_a) {
    var { children, className, style = {} } = _a, props = __rest(_a, ["children", "className", "style"]);
    return (_jsx("section", Object.assign({ className: clsx(classes.container, className), style: Object.assign({}, style) }, props, { children: children })));
}
